$(function () {
    $('.slider-btn').click(function (e) {
        e.preventDefault();
        var $container = $(this).siblings('.call-plan-values-columns');
        var scrollOffset;

        if ($(this).hasClass('slider-prev-btn')) {
            scrollOffset = ($container.scrollLeft() - $container.width()) + 'px';
        } else {
            scrollOffset = ($container.scrollLeft() + $container.width()) + 'px';
        }

        $container.animate({scrollLeft: scrollOffset}, 200);
    });

    var reportingSlider = new Swiper('.reporting_block .swiper-container', {
        slidesPerView: 1,
        loop: true,
        autoplay: 3000,
        nextButton: '.reporting_block .swiper-button-next',
        prevButton: '.reporting_block .swiper-button-prev',
    });

    var pricingSwiper = new Swiper('.call-centres-sip-trunks-plans .swiper-container', {
        slidesPerView: 'auto',
        // Responsive breakpoints
        breakpoints: {
            // when window width is <=
            991: {
                slidesPerView: 'auto',
                centeredSlides: true,
                initialSlide: 1,
            },
        },
        nextButton: '.call-centres-sip-trunks-plans .swiper-button-next',
        prevButton: '.call-centres-sip-trunks-plans .swiper-button-prev',
        grabCursor: true
    });

    $('a[aria-controls="sip-tab"]').on('shown.bs.tab', function () {
        pricingSwiper.update();
        pricingSwiper.slideTo(1);
    });

    // workaround for Swiper, that doesn't work with Bootstrap popover when data-trigger="focus"
    var popovers = $('i[data-toggle="popover"]');
    var popoversKeys = Object.keys(popovers).filter(function (v) {
        return !!popovers[v].id;
    });

    $('body').on('click', function (e) {
        popoversKeys.forEach(function (key) {
            if (popovers[key].id !== e.target.id) {
                $('#' + popovers[key].id).popover('hide');
            }
        });

        if (e.target.id) {
            $('#' + e.target.id).popover('toggle');
        }
    });

    $(window).resize(function () {
        popoversKeys.forEach(function (key) {
            $('#' + popovers[key].id).popover('hide');
        });
    });

    $(window).on('windowResizeBreakpointChanged', function () {
        pricingSwiper.update();
        pricingSwiper.slideTo(1);

    });
});